import React, { useState } from 'react';
import styles from '../../../styles/hardware-partners/hardwarePartner.module.css';
import { AdvanceAnalyticsBanner, BlackCustomButton, HardwareFeatures, HardwareTab, MarqueeComponentHomePage, Tabs, TransparentCustomButton, WhiteCustomButton } from '@/components/qbStrap';
import Image from 'next/image';
import OutletFeatures from '@/components/common/OutletFeatures';
import { ClientsArr1, testimonialData, payuFAQ, videoTestimonial, payuFeatures , getTitleContent } from '@/constants/common';
import ThreeStepForm from '@/components/common/ThreeStepForm';
import TestimonialSection from '@/components/common/TestimonialSection';
import TrustFactor from '@/components/common/TrustFactor';
import FrequentQuestions from '@/components/homePage/FrequentQuestions';
import PersonalisedDemoBanner from '@/components/common/PersonalisedDemoBanner';
import VerificationPopup from '@/components/modals/VerificationPopup';
import { useRouter } from 'next/router';
import content from '../../../language/ENGLISH.json';

const DesktopMswipe = () => {
    // ----constants----
    const paypalFeatures = [
        {
            id: 1,
            image: "/assets/payment-partners/mswipe/contact-less-payment.webp",
            title: "Digital and Contactless Payments",
            desc: "Mswipe integrated with QueueBuster POS offers a comprehensive range of POS solutions for all types of payment acceptance, including cards, wallets, mobile payment apps, bank apps, contactless, and QR payments. ",
            tagColor: "#8AE4F6",
            bgColor: "#8ae4f626",
            imageHeight: "48rem",
            imageWidth: "33rem",
            mobImageHeight: "33rem",
            btnText: "Speak with an expert",
            margin: "0rem",
            points: [
                <>QueueBuster POS with Mswipe supports various payment methods, making it easy for businesses to accept payments through cards, wallets, mobile apps, bank apps, and contactless or QR payments.</>,
                <>By offering digital and contactless payment options, Mswipe integration enhances the customer experience.</>,
                <>Businesses can avail of future-ready solutions that keep them at the forefront of digital payment trends, ensuring they can meet the evolving needs of their customers.</>,
            ],
        },
        {
            id: 2,
            image: "/assets/payment-partners/mswipe/multi-payment-acceptance.webp",
            title: "Multi-Payment Acceptance",
            desc: "Mswipe provides POS terminals at affordable rates and offers the best pricing plans for every business, with zero hidden costs. This transparent and cost-effective pricing model allows businesses to access high-quality POS solutions without exceeding their budget.",
            tagColor: "#FFBA00",
            bgColor: "#fff7e2",
            imageHeight: "45rem",
            imageWidth: "62rem",
            btnText: "Request a callback",
            imageWidth: "34rem",
            mobImageHeight: "38rem",
            margin: "0rem",
            points: [
                <>Mswipe offers POS terminals at competitive rates, making them accessible to businesses of all sizes.</>,
                <>With clear and straightforward pricing plans, businesses can budget effectively and avoid any surprises or hidden fees.</>,
                <>Mswipe POS machines ensure great value for money, providing businesses with reliable POS solutions that deliver optimal performance and functionality.</>,
            ],
        },
    ];

    const paypalFAQ = [
        {
            para: (
                <span style={{ width: "90%" }}>
                    How does QueueBuster POS and mSwipe integration simplify payment acceptance?
                </span>
            ),
            des: "A retail store can accept payments seamlessly using mSwipe's robust devices and payment gateway integrated with QueueBuster POS, offering customers a variety of payment options such as cards, QR codes, and contactless payments.",
            id: 1,
            activeIndex: 1,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    Can businesses manage customer payments efficiently with QueueBuster and mSwipe integration?
                </span>
            ),
            des: "A restaurant using QueueBuster POS can manage customer payments efficiently through mSwipe's payment solutions, streamlining the checkout process and improving overall customer satisfaction.",
            id: 2,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    What advantages do mSwipe and QueueBuster integration offer in terms of customer support?
                </span>
            ),
            des: "An e-commerce business can benefit from round-the-clock customer support provided by mSwipe, integrated with QueueBuster, ensuring quick resolution of payment-related issues and enhancing customer service.",
            id: 3,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    How does the integration of QueueBuster and mSwipe cater to businesses with multilingual customer bases?
                </span>
            ),
            des: "A global business operating in multiple regions can leverage mSwipe's support in 7 regional languages through QueueBuster POS, facilitating effective communication with diverse customer bases.",
            id: 4,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    Can QueueBuster and mSwipe integration help businesses stay updated with digital payment trends?
                </span>
            ),
            des: "A technology store using QueueBuster POS integrated with mSwipe can stay ahead of digital payment trends by offering advanced payment options such as mobile wallets and contactless payments.",
            id: 5,
            activeIndex: 0,
        },

        {
            para: (
                <span style={{ width: "90%" }}>
                    What role do QueueBuster and mSwipe integration play in ensuring secure transactions?
                </span>
            ),
            des: "A financial institution using QueueBuster POS with mSwipe integration benefits from mSwipe's robust security measures, protecting sensitive customer payment data and reducing the risk of fraud.",
            id: 6,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    How does QueueBuster and mSwipe integration enhance the overall customer experience?
                </span>
            ),
            des: "A hotel chain using QueueBuster POS integrated with mSwipe can provide a seamless and convenient payment experience to guests, including mobile payments and quick checkouts.",
            id: 7,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    What cost-effective solutions do QueueBuster and mSwipe integration offer to businesses?
                </span>
            ),
            des: "A small business owner can access affordable POS terminals through mSwipe's integration with QueueBuster POS, without compromising on quality or functionality.",
            id: 8,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    How can QueueBuster and mSwipe integration help businesses in managing inventory and sales data?
                </span>
            ),
            des: "A supermarket using QueueBuster POS integrated with mSwipe can efficiently manage inventory levels and track sales data in real-time, improving inventory management and decision-making.",
            id: 9,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    What support do QueueBuster and mSwipe integration offer for businesses transitioning to digital payments?
                </span>
            ),
            des: "A traditional retail store transitioning to digital payments can benefit from mSwipe's expertise and support through QueueBuster POS integration, ensuring a smooth and successful transition process.",
            id: 10,
            activeIndex: 0,
        },
    ]

    const [demoModal, setDemoModal] = useState(false);
    const [formHeading, setHeading] = useState("Book your free demo now!");
    const router = useRouter();

    const { commonMarqueTitle } = getTitleContent();

    return (
        <>
            <div className={styles.verificationPopupOverride}>
                <VerificationPopup isOpen={demoModal} closeModal={() => setDemoModal(false)} formHeading={formHeading} />
            </div>
            <div className={styles.hero_section}>
                <div className={styles.text_container} style={{ marginTop: "4rem" }}>
                    <div className={styles.hardware_logo} style={{ height: "10rem", width: "20rem" }}><Image src="/assets/Integration/mswipe.webp" alt="mswipe" fill /></div>
                    <h1 className={styles.page_heading}>
                        <span className={styles.small_black_text}>Swift and Seamless Transactions</span><br />
                        <span className={styles.black_text}>With</span><span className={styles.blue_text}> Mswipe Integrated in QueueBuster</span>
                    </h1>
                    <p className={styles.page_desc}>Accept cards, QR, and contactless payments with mSwipe’s robust devices and payment gateway.</p>

                    <div className={styles.btn_container}>
                        <BlackCustomButton text="Try It Free" style={{ padding: "0 2rem" }} onClick={() => (setDemoModal(true), setHeading("14 Days free trial"))} />
                        <TransparentCustomButton text="Contact Sales" style={{ padding: "0 2rem" }} onClick={() => (setDemoModal(true), setHeading("Contact Sales"))} />
                    </div>
                </div>
                <div className={styles.hero_img}><Image src="/assets/payment-partners/mswipe/hero-img.webp" alt="PayU" fill /></div>
            </div>

            <div className={styles.marquee_section}>
                <div className={styles.section_heading}><h3>{commonMarqueTitle}</h3><div className={styles.heading_stroke} style={{ width: '22rem' }}><Image src='/assets/industry/restaurant/features_hl.svg' alt='stroke' fill /></div></div>
                <MarqueeComponentHomePage ClientsArr={ClientsArr1} />
            </div>

            <div className={styles.portable_devices}>
                <h2>Explore what Mswipe and QueueBuster can do for your Businesss</h2>
                <HardwareFeatures features={paypalFeatures} setDemoModal={setDemoModal} setHeading={setHeading} />
            </div>
            <AdvanceAnalyticsBanner setDemoModal={setDemoModal} setHeading={setHeading} />
            <div style={{ margin: "0 9.3rem" }}><ThreeStepForm /></div>

            <div style={{ margin: "5rem 6rem" }}><TestimonialSection testimonialData={testimonialData} videoTestimonial={videoTestimonial} /></div>
            <TrustFactor />

            <FrequentQuestions FaqTableData={paypalFAQ} heading={"FAQs for QueueBuster and PayPal Integration"} />
            <div style={{ margin: "0 9.3rem" }}><PersonalisedDemoBanner setDemoModal={setDemoModal} setHeading={setHeading} /></div>
        </>
    )
}

export default DesktopMswipe